import { Component, Input } from '@angular/core';

@Component({
  selector: 'tracker-admin-alerts-submitter',
  template: require('./admin.alerts.submitter.component.html')
})
export class TrackerAdminAlertsSubmitterComponent {
  @Input() tracker: any;

  OnOff = {
    'On': 'Y',
    'Off': 'N'
  };

  setSubmitterEnabled(value: string) {
    this.tracker.settings.nagAlerts.submitter.isEnabled = value;
  }
}
